import { RequireOnly } from '@pelicargo/types';
import { Markup } from '@prisma/client';

/**
 * A markup bundled into nothing becomes its own top-level line item that every audience sees
 * (see `_lineItem.applyMarkup`), instead of a child of the line items it prices.
 */
export const isSeparateLineItem = (markup: RequireOnly<Markup, 'line_item_types'>) => {
  return !markup.line_item_types?.length;
};
